var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54 5.54a.65.65 0 0 1 .92 0L8 9.08l3.54-3.54a.65.65 0 1 1 .92.92l-4 4a.65.65 0 0 1-.92 0l-4-4a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjUzOTk5IDUuNTQwNDhDMy43OTM4MyA1LjI4NjY0IDQuMjA1MzkgNS4yODY2NCA0LjQ1OTIzIDUuNTQwNDhMNy45OTk2MSA5LjA4MDg2TDExLjU0IDUuNTQwNDhDMTEuNzkzOCA1LjI4NjY0IDEyLjIwNTQgNS4yODY2NCAxMi40NTkyIDUuNTQwNDhDMTIuNzEzMSA1Ljc5NDMyIDEyLjcxMzEgNi4yMDU4OCAxMi40NTkyIDYuNDU5NzJMOC40NTkyMyAxMC40NTk3QzguMjA1MzkgMTAuNzEzNiA3Ljc5MzgzIDEwLjcxMzYgNy41Mzk5OSAxMC40NTk3TDMuNTM5OTkgNi40NTk3MkMzLjI4NjE1IDYuMjA1ODggMy4yODYxNSA1Ljc5NDMyIDMuNTM5OTkgNS41NDA0OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";